import type { PathKeys, PathValue } from "./pathKeys";

export function getValueByPath<T, P extends PathKeys<T>, D = unknown>(
  obj: T,
  path: P,
  defaultValue?: D,
): PathValue<T, P> | D {
  if (!path) {
    return defaultValue as D;
  }
  const segments = path.split(".");
  let current: unknown = obj;
  const isArrayIndex = (s: string): boolean => {
    if (s.length === 0) {
      return false;
    }
    const ZERO = "0".charCodeAt(0);
    const NINE = "9".charCodeAt(0);
    for (let i = 0; i < s.length; i++) {
      const code = s.charCodeAt(i);
      if (code < ZERO || code > NINE) {
        return false;
      }
    }
    return true;
  };
  for (const seg of segments) {
    if (current === null || current === undefined) {
      return (defaultValue as D) ?? (undefined as unknown as PathValue<T, P>);
    }
    if (isArrayIndex(seg)) {
      const idx = Number(seg);
      current = Array.isArray(current) ? current[idx] : undefined;
    } else if (typeof current === "object") {
      current = (current as Record<string, unknown>)[seg];
    } else {
      current = undefined;
    }
  }
  return (current ?? defaultValue) as PathValue<T, P> | D;
}
